export default __webpack_public_path__ + "static/media/IC00051-share.0d6a2cf1.svg";